import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from '../StateProvider';

import HistoryActionFilter from './HistoryActionFilter';
import HistoryUserFilter from './HistoryUserFilter';

import styles from './historyFilters.less';

const HistoryFilters = (props) => {
  const {
    catalogId,
    sceneId,
    filter,
    t,
  } = props;

  return (
    <div className={styles.container}>
      <div className={styles.filterItem}>
        <HistoryActionFilter
          filter={filter}
          catalogId={catalogId}
          sceneId={sceneId}
          t={t}
        />
      </div>
      <div className={styles.filterItem}>
        <HistoryUserFilter
          filter={filter}
          catalogId={catalogId}
          sceneId={sceneId}
        />
      </div>
    </div>
  );
};

HistoryFilters.propTypes = {
  catalogId: PropTypes.string.isRequired,
  sceneId: PropTypes.string.isRequired,
  filter: PropTypes.object,
  t: PropTypes.func,
};

export default withTranslation()(
  connect(
    HistoryFilters,
    {
      catalogsHistory: ['catalogsHistory'],
    },
    (props, { catalogsHistory }) => {
      const filter = catalogsHistory.getIn([props.catalogId, 'filter']);
      return {
        filter,
        ...props,
      };
    },
  ),
);
